import * as React from "react";
import { Button,Icon } from 'antd';
import Confirmation from "widget/orderButtonGroup/confirmation";
import Bucha from "widget/orderButtonGroup/bucha";
import Mssage from "widget/orderButtonGroup/mssage";
import Check from "widget/orderButtonGroup/check";
//import Wechat from "widget/orderButtonGroup/wechat";
//import RefundFee from "widget/orderButtonGroup/refundFee";
import Eorder from "widget/orderButtonGroup/eorder";
import Discount from "widget/orderButtonGroup/discount";
import Send from "widget/orderButtonGroup/send";
import Addorder from "widget/orderButtonGroup/addorder";

interface Data {
  IsMail: any;
}

class botton extends React.Component<Data> {
  state = {
    isMail:0,
  };

  constructor(props: Data) {
    super(props);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if (prevState.isMail != nextProps.IsMail ) {
      this.setState({
        isMail: nextProps.IsMail
      });
      return false;
    }
    return true;
  }

  render() {
    let [mailName,mailClass] = ['',''];
    if(this.state.isMail==0){
       mailName='未发函';
       mailClass = 'close';
    }else{
      mailName='已发函';
      mailClass = 'check';    
    }
    
    return (
      <div className='botton'>
          <Button.Group>
          <Button style={{color:'#1890ff'}} >
            <Icon type={mailClass} />{mailName}
          </Button>
          <Send />
          </Button.Group>
          <div className='bottonju'>
          <Confirmation />
          <Mssage />
          <Bucha />
          <Check /> 
          <Eorder />
          <Discount />
          <Addorder />
          </div>    
      </div> 
    );
  }
}

export default botton;
